<div class="container-fluid">
    <div class="row">
        <div class="card p-0">
            <div class="row m-0">
                <div class="col-sm-6 hidden-mobile left-image">
                </div>
                <div class="col-sm-6  form-div">
                    <img src="../../../../../assets/Logo-new.svg" class="pt-3">
                    <h6>Forgot Password</h6>
                    <form name="form" class="p-2" (submit)="loginForm.form.valid && onSignIn(loginForm)"
                        #loginForm="ngForm" novalidate>
                        <div class="form-row">
                            <div class="form-group col">
                                <input type="text" class="form-control" name="email" appDisableCopyPaste [(ngModel)]="model.email" placeholder="Enter Email Address"
                                    #email="ngModel" [ngClass]="{ 'is-invalid': loginForm.submitted && email.invalid }" maxlength="50" 
                                    required email />
                                <div *ngIf="loginForm.submitted && email.invalid" class="invalid-feedback-text">
                                    <div *ngIf="email.errors.required">Email is required</div>
                                    <div *ngIf="email.errors.email">Email must be a valid email address</div>
                                </div>
                            </div>

                            
                            
                        </div>
                        <div class="text-center mt-4 ">
                        <button class=" btn mr-1 mb-2" type="submit">Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>


